import useSearchParams from '@/components/search/hooks/useSearchParams';
import React, { memo } from 'react';
import SortingMenuMobile from './sortingMenuMobile/SortingMenuMobile';
import SortingMenuDesktop from './sortingMenuDesktop/SortingMenuDesktop';
import useDevice from '@/hooks/useDevice';
import styles from './SortingMenu.module.scss';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import Typography from '@/components/UI/typography/Typography';
const SortingMenu = () => {
  const {
    isMobile
  } = useDevice();
  const {
    setQuery
  } = useSearchParams();
  const handleChangeSort = (index: number) => {
    setQuery({
      sortBy: index
    });
  };
  return <>
      {isMobile ? <SortingMenuMobile handleSort={handleChangeSort} /> : <Box className={styles['sorting-menu-container']}>
          <Box className={styles['sorting-title-section']}>
            <Icon name="arrow-3" type="highEmphasis" />
            <Typography variant="bodyM">مرتب سازی:</Typography>
          </Box>
          <SortingMenuDesktop handleSort={handleChangeSort} />
        </Box>}
    </>;
};
export default memo(SortingMenu);